import { InfoCircledIcon } from "@radix-ui/react-icons";
import { Callout } from "@radix-ui/themes";
import { FC, JSX } from "react";
import { AlertProps } from "./Alert.types";

const Alert: FC<AlertProps> = ({ children, color }): JSX.Element => {
  return (
    <Callout.Root color={color ? color : "red"}>
      <Callout.Icon>
        <InfoCircledIcon />
      </Callout.Icon>
      <Callout.Text>{children}</Callout.Text>
    </Callout.Root>
  );
};

export default Alert;
